<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapter">CONTENTS</h1>
<p class="toc"><a href="#/OEBPS/listofmap.htm"><em>List of Maps</em></a></p>
<p class="toc"><a href="#/OEBPS/acknow.htm"><em>Acknowledgements</em></a></p>
<p class="toc"><a href="#/OEBPS/anote.htm"><em>A Note on Transliteration and Dating</em></a></p>
<p class="toc"><a href="#/OEBPS/intro.htm"><em>Introduction</em></a></p>
<br/><br/>
<p class="toc"><a href="#/OEBPS/ch01.htm">1. Before Islam</a></p>
<p class="toc"><a href="#/OEBPS/ch02.htm">2. The Prophet Mohammed and the Jews</a></p>
<p class="toc"><a href="#/OEBPS/ch03.htm">3. Protection or Persecution?</a></p>
<p class="toc"><a href="#/OEBPS/ch04.htm">4. The First Four Hundred Years Under Islam</a></p>
<p class="toc"><a href="#/OEBPS/ch05.htm">5. Jews and Muslims in the Age of the Crusades</a></p>
<p class="toc"><a href="#/OEBPS/ch06.htm">6. The Ottoman Sultans and Other Muslim Rulers, 1324 015–1699</a></p>
<p class="toc"><a href="#/OEBPS/ch07.htm">7. The Eighteenth and Nineteenth Centuries</a></p>
<p class="toc"><a href="#/OEBPS/ch08.htm">8. Progress and Peril: Towards the Twentieth Century</a></p>
<p class="toc"><a href="#/OEBPS/ch09.htm">9. The First Years of the Twentieth Century and the Emergence of Zionism</a></p>
<p class="toc"><a href="#/OEBPS/ch10.htm">10. Jewish and Arab Nationalism: The First World War and After</a></p>
<p class="toc"><a href="#/OEBPS/ch11.htm">11. The Nineteen Thirties</a></p>
<p class="toc"><a href="#/OEBPS/ch12.htm">12. The Second World War: A Time of Danger</a></p>
<p class="toc"><a href="#/OEBPS/ch13.htm">13. Towards Liberation, and an Uncertain Future</a></p>
<p class="toc"><a href="#/OEBPS/ch14.htm">14. The United Nations Palestine Partition Resolution</a></p>
<p class="toc"><a href="#/OEBPS/ch15.htm">15. The Creation of the State of Israel, 14 May 1948</a></p>
<p class="toc"><a href="#/OEBPS/ch16.htm">16. Iraq, 1948–1952</a></p>
<p class="toc"><a href="#/OEBPS/ch17.htm">17. Egypt, 1951–1961</a></p>
<p class="toc"><a href="#/OEBPS/ch18.htm">18. The Exodus Continues, 1950–1967</a></p>
<p class="toc"><a href="#/OEBPS/ch19.htm">19. The Six–Day War of 1967 and Its Aftermath</a></p>
<p class="toc"><a href="#/OEBPS/ch20.htm">20. A New Life in New Lands</a></p>
<p class="toc"><a href="#/OEBPS/ch21.htm">21. The Search for Recognition</a></p>
<p class="toc"><a href="#/OEBPS/ch22.htm">22. Jews Who Remain in Muslim Lands</a></p>
<br/><br/>
<p class="toc"><a href="#/OEBPS/map.htm"><em>Maps</em></a></p>
<p class="toc"><a href="#/OEBPS/glos.htm"><em>Glossary</em></a></p>
<p class="toc"><a href="#/OEBPS/bib.htm"><em>Bibliography</em></a></p>
<p class="toc"><a href="#/OEBPS/index.htm"><em>Index</em></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7011e821